import { useIntl } from 'react-intl'

export const useFormatMessage = () => {
  const { formatMessage } = useIntl()

  const f = (id: string): string => formatMessage({ id })

  return { f }
}
